import { create } from 'zustand';


export interface IUnsavedChangesDialogState {
    showUnsavedChangesPrompt: boolean;
    setShowUnsavedChangesPrompt: (val: boolean) => void,
}

const useUnsavedChangesDialogStore = create<IUnsavedChangesDialogState>((set) => ({
    showUnsavedChangesPrompt: false,
    setShowUnsavedChangesPrompt: (showUnsavedChangesPrompt: boolean) => set(() => ({ showUnsavedChangesPrompt })),

}));

export default useUnsavedChangesDialogStore;